function slugFromSrc(src) {
  const file = src.split('/').pop() ?? '';
  return file.replace(/\.[^.]+$/, '');
}

/**
 * Imagem responsiva com variantes em /media/{slug}-{width}.webp (geradas no build).
 */
export default function ResponsiveImage({
  src,
  alt,
  width,
  height,
  sizes,
  loading = 'lazy',
  className,
  widths = [600, 1200],
}) {
  const slug = slugFromSrc(src);
  const srcSet = widths.map((w) => `/media/${slug}-${w}.webp ${w}w`).join(', ');
  const fallback = `/media/${slug}-${widths[widths.length - 1]}.webp`;

  return (
    <picture>
      <source type="image/webp" srcSet={srcSet} sizes={sizes} />
      <img
        src={fallback}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        className={className}
      />
    </picture>
  );
}

export const FEATURE_IMAGE_SIZES = '(max-width: 991px) 100vw, 560px';
export const PORTFOLIO_IMAGE_SIZES = '(max-width: 640px) 100vw, (max-width: 991px) 50vw, 400px';
export const LOGO_IMAGE_SIZES = '120px';
